//import {Dimensions} from 'react-native';
import {isWebDesktopView} from '.';

export function isLandscape() {
  const isWebDesktop = isWebDesktopView();
  //const {width, height} = Dimensions.get('window');

  return isWebDesktop ? true : false;
}
